<template>
<div class="">
    <v-row align="start" no-gutters>
        <v-col cols="12" md="8" offset-md="2" class="py-0">
            <v-alert outlined type="info" text class="pa-2">
                <template v-slot:prepend>
                    <v-icon size="24" color="blue" class="mr-2">info</v-icon>
                </template>
                <span>
                    Inainte de a continua, va rugam sa verificati sumarul informatiilor completate pana acum.
                </span>
            </v-alert>
        </v-col>
    </v-row>
    <v-row no-gutters>
        <v-col md="4" cols="12" class="pa-2">
            <div class="major py-2">Hotel</div>
            <v-card height="80%">
                <v-card-text>
                    <v-btn color="primary" text right absolute icon @click="goToHotel()">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <div class="major font-weight-regular">{{ hotel.name }}</div>
                    <div class="d-flex py-1">
                        <v-icon size="18">mail</v-icon>
                        <div class="regular px-1">{{ hotel.email }}</div>
                    </div>
                    <div class="d-flex py-1">
                        <v-icon size="18">phone</v-icon>
                        <div class="regular px-1">{{ hotel.static.defaults.phone }}</div>
                    </div>
                    <div class="important py-1">Adresa</div>
                    <div class="d-flex py-1">
                        <div class="regular px-1">Judetul: {{ hotel.static.geo.region }},</div>
                        <div class="regular px-1">Localitatea: {{ hotel.static.geo.city}}</div>
                    </div>
                    <div class="d-flex">
                        <div class="regular px-1">str: {{ hotel.static.geo.address }}</div>
                        <div v-if="hotel.address.number" class="regular px-1">, nr. {{ hotel.address.number }}</div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="12" md="4" class="pa-2">
            <div class="major py-2">Date financiare</div>
            <v-card height="80%">
                <v-card-text>
                    <v-btn color="primary" text right absolute icon @click="goToOrganization()">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <div class="major font-weight-regular px-1">{{ organization.name }}</div>
                    <div class="d-flex">
                        <div class="important px-1">Cod fiscal: </div>
                        <div class="regular px-1">{{ billing.fiscal_code }}</div>
                    </div>
                    <div class="d-flex">
                        <div class="important px-1">Nr reg comertului: </div>
                        <div class="regular px-1">{{ billing.registry_number }}</div>
                    </div>
                    <div class="important py-1">Adresa </div>
                    <div class="d-flex">
                        <div class="regular px-1">Judet: {{ organization.address.region }},</div>
                        <div class="regular px-1">Localitatea: {{ organization.address.city }}</div>
                    </div>
                    <div class="d-flex">
                        <div v-if="organization.address.street" class="regular pl-1">str. {{ organization.address.street }}</div>
                        <div v-if="organization.address.number" class="regular px-1">, nr. {{ organization.address.number }}</div>
                    </div>
                    <div class="important" v-if="billing.banks[0].name || billing.banks[0].account || billing.banks[0].currency">
                        <div class="important ">Banca</div>
                        <div class="regular px-1">{{ billing.banks[0].name }}</div>
                        <v-row class="regular px-1">
                            <v-col cols="9">
                                <div class="">{{ billing.banks[0].account }}</div>
                            </v-col>
                            <v-col cols="3">
                                <div class="">{{ billing.banks[0].currency }}</div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col md="4" cols="12" class="pa-2">
            <div class="major py-2">Utilizator</div>
            <v-card height="80%">
                <v-card-text>
                    <v-btn class="mx-1" color="primary" text right absolute icon @click="goToUser()">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <div>
                        <div class="important font-weight-regular">
                            <div class="">
                                <span class="px-1">{{ user.first_name }}</span>
                                <span>{{ user.last_name }}</span>
                            </div>
                            <div class="d-flex py-1">
                                <v-icon size="18">mail</v-icon>
                                <div class="px-1">{{ user.email }}</div>
                            </div>
                        </div>
                        <div class="" v-if="password">
                            <div class="regular">Aveti un cont existent. Introduceti parola sau resetati parola</div>
                            <v-text-field class="register-input ma-0 pa-0" v-model="user.password" hide-details :append-icon="show_pass ? 'visibility' : 'visibility_off'" :type="show_pass ? 'text' : 'password'" :rules="rules.min" required
                                @click:append="show_pass = !show_pass" />
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</div>
</template>

<script>
export default {
    name: 'HotelRegistration',
    props: {
        organization: {
            type: Object,
        },
        billing: {
            type: Object,
        },
        hotel: {
            type: Object,
        },
        user: {
            type: Object,
        },
        password: {
            type: Boolean,
        },
    },
    data() {
        return {
            show_pass: false,
        }
    },
    computed: {
        rules() {
            return {
                min: [v => /(?=.{8,})/.test(v) || 'Min 8 characters']
            }
        },
    },
    methods: {
        goToHotel() {
            this.$emit('editHotel')
        },

        goToOrganization() {
            this.$emit('editOrganization')
        },

        goToUser() {
            this.$emit('editUser')
        }
    }

}
</script>

<style lang="stylus">
.register-input
    &.v-text-field
        &.v-text-field--solo
            .v-input__control
                min-height: auto
</style>
